import React from "react";
import { motion } from "motion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@awesome.me/kit-70c1f0055f/icons/classic/light";
import { LoadingIndicator } from "./LoadingIndicator";

interface StatusIndicatorProps {
  status: string;
  className?: string;
}

export function StatusIndicator({
  status,
  className = "",
}: StatusIndicatorProps) {
  if (status === "completed") {
    return (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className={`text-green-500 dark:text-green-400 ${className}`}
      >
        <FontAwesomeIcon icon={faCheck} />
      </motion.div>
    );
  }

  if (status === "in_progress") {
    return (
      <LoadingIndicator
        className={className}
        dotCount={3}
        dotSize={3}
        dotSpacing={2}
        animationType="wave"
        showText={false}
      />
    );
  }

  return null;
}
